import dynamic from 'next/dynamic'

const LoadingAnimation = dynamic(
  () => import('./ClientLoadingAnimation'),
  { ssr: false },
)

export default LoadingAnimation
